import React from 'react'
import { EditOutlined } from "@mui/icons-material";
import { Button, Divider } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import EnableDisableButton from "components/Shared/EnableDisableButton";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useGetShipmentUnLoadingDetailQuery, useUpdateShipmentUnLoadingMutation } from "store/services/shipmentUnLoadingApi";
import { ShipmentUnLoadingDetailContext, useShipmentUnLoadingDetailContext } from "contexts/ShipmentUnLoadingDetailContext";
import ShipmentUnLoadingBasicDetail from "./ShipmentUnLoadingComponents/ShipmentUnLoadingBasicDetail";
import ShipmentUnLoadingDetailTab from "./ShipmentUnLoadingComponents/ShipmentUnLoadingDetailTab";
import { useAuth } from "hooks";



const ShipmentUnLoadingDetailScreen = () => {

  const { id } = useParams();
  const {isDriver} = useAuth();
  const breadcrumb = [
    { title: "Shipment Unloading", path: !isDriver ? "/app/crm/shipment-unLoading/list" : "/app/driver/unloading" },
    { title: "Unloading Detail" }
  ]

  // RTK Query
  const { data: shipmentUnLoadingDetail, isLoading: loadingShipmentUnLoading, error,
  } = useGetShipmentUnLoadingDetailQuery(id);

  return (
    <ShipmentUnLoadingDetailContext.Provider value={{ shipmentUnLoadingDetail, loadingShipmentUnLoading }}>
      <BreadcrumbLayout breadcrumbs={breadcrumb}
        isBusy={loadingShipmentUnLoading}
        headerActions={<PageActions />} >
        <BreadcrumbLayout.Error error={error} />
        <BreadcrumbLayout.Paper>
          <ShipmentUnLoadingBasicDetail />
          <Divider />
          <ShipmentUnLoadingDetailTab/>
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </ShipmentUnLoadingDetailContext.Provider>
  )
}

export default ShipmentUnLoadingDetailScreen;

const PageActions = () => {
  const { isDriver, isAccountAdmin } = useAuth();

  // RTK Query
  const { shipmentUnLoadingDetail, loadingShipmentUnLoading }
    = useShipmentUnLoadingDetailContext();


  const [updateShipmentUnLoading, { isLoading: updatingShipmentUnLoading }]
    = useUpdateShipmentUnLoadingMutation();

  // methods
  const handelToggleShipmentLoadingStatus = async () => {
    try {
      await updateShipmentUnLoading({
        _id: shipmentUnLoadingDetail._id,
        isActive: !shipmentUnLoadingDetail.isActive,
      }).unwrap();
      toast.info(`Shipment Unloading ${shipmentUnLoadingDetail.isActive ? "Disable" : "Enable"} !`);
    } catch (error) {
      toast.error(error?.data.message ?? "Could Not Update Status");
    }
  }

  return (
    <>
    {!isDriver && (<div className="flex space-x-4">
        {isAccountAdmin &&(<EnableDisableButton
        isActive={shipmentUnLoadingDetail?.isActive}
        loading={loadingShipmentUnLoading || updatingShipmentUnLoading}
        onClick={handelToggleShipmentLoadingStatus}
      />)}
      <Link to={`/app/crm/shipment-unLoading/${shipmentUnLoadingDetail?._id}/edit`}>
        <Button startIcon={<EditOutlined />} variant="contained">
          Edit
        </Button>
      </Link>
    </div>)}
    </>
  );
};
